export const page = {
  vw: 0,
  vh: 0,
  fh: 0,
};

export const flags = {
  isSmooth: false,
  isResizing: false,
  isLocked: true,
  isHomePage: false,
  isFocus: false,
};

export const breakpoints = {
  xsmallDown: false,
  smallDown: false,
  smallUp: false,
  mediumDown: false,
  mediumUp: false,
};

// export const scroll = {
//   el: null,
//   current: 0
// }

export const mouse = {
  el: null,
  x: 0,
  y: 0,
};

export const menu = {
  isOpen: false,
};

export const gl = {
  el: null,
  renderer: null,
  camera: null,
  scenes: [],
};

export default {
  author: {
    name: "Non-Linear",
    link: "https://www.non-linear.studio/",
  },
  currentPage: null,
  contentPage: null,
  currentURL: null,
  page,
  flags,
  breakpoints,
  //scroll,
  mouse,
  gl,
};
